exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".arrow-forward[data-v-520b4bef] path {\n  fill: #F08B71;\n}\n", ""]);
